import parse from "html-react-parser";
import Image from "next/image";

interface ICompanyLogo {
  content: string;
  logo: string;
  title: string;
}

export const CompanyLogo = ({ title, logo, content }: ICompanyLogo) => {
  return (
    <div className="mb-8 flex flex-col md:flex-row">
      <div
        className="my-3 flex-grow"
        // dangerouslySetInnerHTML={{ __html: content }}
      >
        {content && parse(content || "")}
      </div>
      <div className="mx-auto grid w-64 flex-none place-content-center">
        <Image
          alt={title}
          height={181}
          src={`/img/partners/${logo}.png`}
          width={251}
        />
      </div>
    </div>
  );
};
